import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { ClientInferResponseBody } from "@ts-rest/core";
import { apiContract } from "tekkr-common/dist/model/api/api.contract";

interface Input {
    name: string;
    title?: string;
    department?: string;
    email: string;
    sendInvite: boolean;
}

interface Data {
    id: string;
    name: string;
}

interface Options {
    onSuccess?: (data: Data) => void;
}

export function useCreateOrgUserMutation(options?: Options) {
    return useMutation({
        mutationFn: async (input: Input) => {
            const response = await apiClient.createOrgUser({
                body: {
                    name: input.name,
                    title: input.title,
                    department: input.department,
                    email: input.email,
                },
                query: {
                    emailInvite: input.sendInvite ? "true" : "false",
                },
            });
            return response.body as ClientInferResponseBody<typeof apiContract.createOrgUser, 201>;
        },
        onSuccess: options?.onSuccess,
    });
}
